import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "modal is-active" }
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-body" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "control" }
const _hoisted_7 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_8 = {
  key: 1,
  class: "help is-danger"
}
const _hoisted_9 = {
  key: 2,
  class: "help is-danger"
}
const _hoisted_10 = { class: "modal-card-foot" }

import { nanoid } from 'nanoid';
import { InputVariableViewModel } from '@/features/bots/models/designer';
import { ADD_FLOW_VARIABLE } from '@/store/bot-designer/mutationTypes';
import { required, maxLength } from '@vuelidate/validators';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import useVuelidate from '@vuelidate/core';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddNewVariableModal',
  emits: ["added", "close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store = useStore();
const flowVariables = computed<InputVariableViewModel[]>(() => store.getters.flowVariables);
const addFlowVariable = (flowVar: InputVariableViewModel) => store.commit(ADD_FLOW_VARIABLE, flowVar);

const newVarName = ref('');
const variableInput = ref<HTMLInputElement | null>(null);

const validations = {
  newVarName: {
    required,
    maxLength: maxLength(50),
    unique: (value: string) => !flowVariables.value.some((v) => v.scope === 'flow' && v.name === value),
  },
};

const $v = useVuelidate(validations, { newVarName });

onMounted(() => {
  if (variableInput.value) {
    variableInput.value.focus();
  }
});

function save() {
  if ($v.value.$invalid) {
    return;
  }

  const id = nanoid(7);
  const newVar = {
    id: `var-${id}`,
    scope: 'flow',
    key: newVarName.value,
    name: newVarName.value,
  };

  addFlowVariable(newVar);
  emit('added', newVar);
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "modal-background" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "modal-card-title" }, "Create new variable", -1)),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
          class: "delete",
          "aria-label": "close"
        })
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "Name", -1)),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              class: _normalizeClass(["input", { 'is-danger': _unref($v).newVarName.$invalid && _unref($v).newVarName.$dirty }]),
              ref_key: "variableInput",
              ref: variableInput,
              type: "text",
              placeholder: "Enter variable name",
              maxlength: "50",
              required: "",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newVarName).value = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_unref($v).newVarName.$touch()))
            }, null, 34), [
              [
                _vModelText,
                newVarName.value,
                void 0,
                { trim: true }
              ]
            ]),
            (_unref($v).newVarName.$dirty && !_unref($v).newVarName.required)
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, "Name is required"))
              : _createCommentVNode("", true),
            (_unref($v).newVarName.$dirty && !_unref($v).newVarName.maxLength)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, " Name must not be longer than " + _toDisplayString(_unref($v).name.$params.maxLength.max) + " characters ", 1))
              : _createCommentVNode("", true),
            (_unref($v).newVarName.$dirty && !_unref($v).newVarName.unique)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Name is already in use as a flow variable "))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("footer", _hoisted_10, [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              variant: "primary",
              disabled: _unref($v).$invalid,
              onClick: save
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_n_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('close'))),
              variant: "primary--outline"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})